import CampaignDashboard from '@/components/campaign/CampaignDashboard';
import CampaignDetailContainer from '@/containers/campaign/CampaignDetailContainer';

export default [
  {
    path: '/campaigns',
    name: 'Campaign',
    meta: { requiresAuth: true, action: 'view', subject: 'campaigns' },
    component: CampaignDashboard,
  },
  {
    path: '/campaigns/:id',
    name: 'CampaignDetail',
    meta: { requiresAuth: true, action: 'view', subject: 'campaigns' },
    component: CampaignDetailContainer,
  },
];



// WEBPACK FOOTER //
// ./src/router/campaign.js